import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';

import { CREATE_NOTIFICATION, REMOVE_NOTIFICATION } from './actions';

/*
 * A toast object should have at least a message. There is an optional status
 * which controls the color of the toast. Each toast lives in `state.queue` and
 * is removed when no longer displayed. The keys in the toast object should
 * match the available props on the Toast component.
 *
 * @example
 *
 * {
 *   message: 'Invalid phone number ${phone}.',
 *   variables: { phone: '123' },
 *   status: 'error',
 * }
 */
export const INITIAL_STATE = Immutable({
  notification: null,
});

export const actionMap = {
  [CREATE_NOTIFICATION]: (state, { payload }) =>
    Immutable({ notification: payload }),
  [REMOVE_NOTIFICATION]: () => INITIAL_STATE,
};

export default handleActions(actionMap, INITIAL_STATE);
